module.exports = __webpack_public_path__ + "static/fd4c56df6c3b443af7b3adc05d32a71228b4a041d041528ec1e4a2533e2fa35f-585236c57d6152f169fcf7a1b0598fea.png";